/**
 * Suggested frequency bands.
 *
 * Offered as one-tap additions in the avoid list. Nothing here is applied
 * unless a profile chooses it — the avoid list starts empty.
 */

import type { Band } from './types';

/**
 * 13–30 Hz.
 *
 * Four independent lines converge on 15–25 Hz: peak photosensitivity
 * provocation (15–20 Hz), the magnetophosphene threshold minimum (20 Hz), the
 * ICNIRP restriction minimum (10–25 Hz) and the IEEE brain limit minimum
 * (20 Hz). Margin added either side.
 */
export const BAND_PHOTOSENSITIVE: Band = {
  lo: 13,
  hi: 30,
  reason: 'Photosensitivity and magnetophosphene thresholds are lowest here.',
};

/**
 * 45–65 Hz.
 *
 * 50–60 Hz is used during cortical mapping to deliberately provoke seizures.
 * He 2013 found neuronal sodium current density up 30–125% at 50 Hz / ~1 mT.
 * It is also mains frequency in most of the world.
 */
export const BAND_PROVOCATION: Band = {
  lo: 45,
  hi: 65,
  reason: 'The range used clinically to provoke seizures. Also mains frequency.',
};

/** Offered in the avoid-band editor as quick additions. */
export const SUGGESTED_BANDS: { label: string; band: Band }[] = [
  { label: '13–30 Hz — photosensitivity', band: BAND_PHOTOSENSITIVE },
  { label: '45–65 Hz — mains / provocation', band: BAND_PROVOCATION },
];
